import type { CSSProperties } from 'react';
import React from 'react';
import { Badge } from '@components/atoms/badge';
import { BadgeStatusEnum } from '@models/enums';
import { styled } from '@mui/material/styles';

export type PaidIconProps = {
    badgeStyle?: CSSProperties;
    className?: string;
};

const Icon: React.FC<PaidIconProps> = ({ badgeStyle = {}, className }) => (
    <Badge
        text='PAID'
        status={BadgeStatusEnum.PRIMARY}
        size='s'
        style={{
            ...badgeStyle,
        }}
        className={className}
    />
);

export const PaidIcon = styled(Icon)({});
